{
  "de": {
    "aiChat": {
      "aiAssistant": {
        "explore": {
          "filters": {
            "all": "Highlights",
            "character": "Personas",
            "model": "KI-Sprachmodelle",
            "plugin": "Plugins",
            "pupils": "Schüler*innen",
            "teachers": "Lehrkräfte"
          },
          "titles": {
            "administration": "Schulverwaltung und Organisation",
            "exercises": "Übungen und Lernhelfer*innen",
            "featured": "Beliebte Assistenten",
            "feedback": "Feedback und Bewertung",
            "information": "Information und Orientierung",
            "inspiration": "Inspiration und Kreatives",
            "material": "Material und Aufgaben",
            "model": "Plugins",
            "other": "Sonstige",
            "planning": "Unterrichtsplanung und Organisation",
            "roleplay": "Chatbots für Rollenspiele"
          }
        },
        "errors": {
          "skillUploadFailed": "Skill konnte nicht hochgeladen werden. Bitte versuche es erneut.",
          "maxSkillsReached": "Maximal {max} Skills pro Assistent.",
          "saveFailed": "Änderungen konnten nicht gespeichert werden. Bitte versuche es erneut.",
          "skillContentTooLong": "Der Skill-Inhalt überschreitet die maximale Länge von 20.000 Zeichen.",
          "skillBundleInvalid": "Das Skill-Bundle ist ungültig oder enthält unsichere Dateipfade.",
          "skillBundleMissingSkill": "Das Skill-Bundle muss eine SKILL.md im Stammverzeichnis oder in einem einzelnen übergeordneten Ordner enthalten.",
          "skillBundleTooLarge": "Das Skill-Bundle oder eine enthaltene Datei überschreitet die erlaubte Größe.",
          "skillBundleTooManyFiles": "Das Skill-Bundle darf höchstens 200 Dateien enthalten."
        },
        "hints": {
          "fileExtractingText": "Text wird extrahiert...",
          "fileParsingImages": "Bilder werden verarbeitet: {progress}%",
          "fileIndexingFailed": "Datei konnte nicht indiziert werden",
          "fileIndexingRunning": "Datei wird indiziert",
          "fileIndexingProgress": "Indizierung: {progress}%",
          "fileIndexingSuccessfully": "Datei erfolgreich indiziert",
          "largeFileUploaded": "Der hochgeladene Text ist sehr groß und eignet sich gut als Hintergrundwissen für konkrete Fragen zum Text und Reproduktionsaufgaben (AFB I).",
          "maxHandoffsReached": "Maximal {max} Handoff-Assistenten pro Assistent.",
          "noHandoffAssistants": "Keine passenden Assistenten gefunden.",
          "skillDocLink": "Mehr erfahren",
          "skillUploadLimits": "(max. {max} Skills, {formats}, je max. {size} MB)",
          "skillsFormatsBundle": "Lade eine Markdown-Datei (.md) oder ein ZIP-Bundle mit einer SKILL.md hoch.",
          "skillsIntro": "Skills sind Arbeitsanleitungen, die dein Assistent bei Bedarf lädt, z. B. ein Bewertungsraster oder ein festes Vorgehen für Aufgaben."
        },
        "infoMessages": {
          "assistantFiles": "Hier kannst du deinem Assistenten zusätzliches Hintergrundwissen hochladen, auf das dieser in einer Anfrage zugreifen kann. Beachte, dass dein Assistent nicht auf Bilder in PDFs zugreifen kann.",
          "conversationStarters": "Formuliere eine klare Aufforderung an das Sprachmodell, um eine spezifische Aufgabe zu erledigen. Zum Beispiel: 'Erstelle mir einen Unterrichtsplan.'",
          "enabledTools": "Mithilfe von Plugins kann dein Assistent verschiedene Tools aufrufen oder Bilder generieren.",
          "handoffAssistants": "Wähle bis zu zwei Assistenten aus, an die dieser Assistent während einer Unterhaltung Aufgaben delegieren darf.",
          "skillsSection": "Skills sind Arbeitsanleitungen, die dein Assistent bei Bedarf lädt. Sie gehören zu diesem Assistenten.",
          "systemPrompt": "In der Instruktion kannst du die Aufgabe für deinen Assistenten formulieren. Im Katalog findest du den KI-Assistenten Rob, den Rollenpromptexperten, der dir bei der Formulierung hilft."
        },
        "labels": {
          "author": "Autor*in",
          "enabledTools": "Plugins",
          "handoffAssistants": "Handoff-Assistenten",
          "model": "Model",
          "openModels": "Offene Modelle",
          "otherModels": "Andere Modelle",
          "recommendedModels": "Empfohlene Modelle",
          "remixCount": "Remix",
          "skillFileCount": "1 Datei | {count} Dateien",
          "systemPrompt": "Rolle und Instruktionen"
        },
        "links": {
          "create": "Assistent anlegen",
          "downloadSkill": "Skill herunterladen",
          "removeSkill": "Skill entfernen",
          "replaceSkill": "Datei ersetzen",
          "uploadSkill": "Skill hochladen"
        },
        "paragraphs": {
          "alert": "Egal ob für dich oder deine Schüler:innen, dein eigener Assistent ist fokussiert auf einen bestimmen Anwendungsbereich. Du kannst z.B. Dokumente wie Bilder oder Zeitungsartikel hochladen und dazu gezielt Aufgaben stellen.",
          "alertPupil": "Dein eigener Assistent ist fokussiert auf einen bestimmen Anwendungsbereich. Du kannst z.B. Dokumente wie Bilder oder Zeitungsartikel hochladen und dazu gezielt Aufgaben stellen."
        },
        "placeholders": {
          "conversationStarter": "Gib eine vorgeschlagene Frage oder Aufforderung ein...",
          "description": "Kurze Erklärung für die Nutzer*innen, was dein Assistent kann...",
          "searchHandoffAssistants": "Assistenten für Handoff suchen...",
          "systemPrompt": "Lege hier genau fest, wie sich dein Assistent in welchen Situationen verhalten soll, welche Plugins und Quellen er oder sie in welchen Fällen bevorzugt nutzen und welche Rolle er oder sie im Chat einnehmen soll."
        },
        "titles": {
          "alert": "Hier kannst du ganz einfach deinen eigenen Assistent anlegen",
          "community": "Entdecke KI-Assistenten für deinen Schulalltag",
          "create": "Erstelle und teile deine eigenen Assistenten"
        },
        "tooltips": {
          "clickToUploadAvatar": "Klicke oder ziehe ein Bild hierher",
          "generateAvatar": "Bild generieren",
          "generateConversationStarter": "Chatstarter-Vorschlag generieren",
          "generateConversationStarterDisabled": "Fülle Name und Beschreibung aus, um einen Chatstarter generieren zu lassen",
          "generatePrompt": "Instruktion generieren",
          "adminOnly": "Nur für Admins sichtbar 🤓",
          "generatePromptDisabled": "Fülle Name und Beschreibung aus, um eine Instruktion generieren zu lassen",
          "remixNotAllowed": "Für diesen Assistenten ist der Remix nicht erlaubt."
        }
      },
      "confirm": {
        "deleteAssistant": {
          "text": "Der Assistent wird aus deiner Übersicht entfernt. Du findest ihn danach im Papierkorb.",
          "title": "Assistent löschen?"
        },
        "deleteChat": {
          "text": "Diese Aktion kann nicht rückgängig gemacht werden. Der Chat {modelName} wird mit allen Nachrichten dauerhaft gelöscht.",
          "title": "Chat löschen?"
        },
        "deleteSkill": {
          "title": "Skill „{title}“ löschen?",
          "text": "Der Skill wird aus diesem Assistenten entfernt. Das lässt sich nicht rückgängig machen."
        }
      },
      "conversationGroups": {
        "last30Days": "Letzte 30 Tage",
        "last7Days": "Letzte 7 Tage",
        "older": "Älter",
        "today": "Heute",
        "yesterday": "Gestern"
      },
      "conversationStartersDefault": {
        "prompt1": "Erstelle ein Brainstorming mit fünf kreativen Ideen für eine Einführung in das Thema \"Elektrischer Widerstand\" in der Physik für eine 9. Klasse",
        "prompt2": "Entwickle drei offene Prüfungsaufgaben zur Charakteranalyse von \"Der Besuch der alten Dame\" für einen Deutschkurs der 11. Klasse einer Gesamtschule",
        "prompt3": "Schreibe eine Einladung zum Elterngespräch am 25. September um 18:30 Uhr.",
        "prompt4": "Erstelle einen tabellarischen Unterrichtsplan für eine 90-minütige Mathematikstunde in der 8. Klasse zum Thema \"Satz des Pythagoras\"."
      },
      "conversationStartersStudents": {
        "prompt1": "Erkläre mir, wie ich diese Aufgabe lösen kann: \"Schreibe eine Gedichtsinterpretation\"",
        "prompt2": "Kannst du mir erklären, was \"Mitose\" ist?",
        "prompt3": "Ich soll ein Referat über die Europäische Union halten. Hilf mir, ein Thema zu finden.",
        "prompt4": "Hilf mir, mich auf eine Politik Klassenarbeit über den \"Brexit\" vorzubereiten."
      },
      "errors": {
        "conversationCreateFailed": "Fehler beim Erstellen der Unterhaltung. Bitte versuche es erneut.",
        "fileAlreadyExists": "Datei '{filename}' bereits hochgeladen",
        "fileRemoveFailed": "Fehler beim Entfernen der Datei",
        "fileUploadFailed": "Fehler beim Hochladen von '{filename}'",
        "maxFilesReached": "Maximal {max} Dateien erlaubt",
        "visionNotSupportedDescription": "Bitte wechsle das Modell oder entferne das Bild.",
        "visionNotSupportedTitle": "Das ausgewählte Modell unterstützt keine Bilder"
      },
      "form": {
        "avatar": "Wie sieht dein Assistent aus?",
        "fileLimit": "(max. {maxFiles} Dateien, je max. {size} MB, gesamt max. {totalSize} MB)",
        "files": "Hat dein Assistent spezielle Hintergrundinformationen?",
        "imageHint": "Erstelle ein KI-generiertes Vorschaubild oder {uploadLink}.",
        "knowledge": "Wer ist dein Assistent und was kann er?",
        "skills": "Welche Skills soll dein Assistent beherrschen?",
        "title": "Assistent anlegen",
        "upload": "Hintergrundwissen hochladen",
        "uploadLinkText": "lade ein eigenes Bild hoch"
      },
      "headers": {
        "editConversation": "Konversation umbenennen"
      },
      "help": {
        "scrollToBottom": "Nach unten scrollen",
        "scrollToTop": "Nach oben scrollen",
        "startSpeech": "Antwort abspielen",
        "stopSpeech": "Abspielen stoppen",
        "switchGoogleAccount": "Google Account wechseln",
        "uploadFileDescription": "Mögliche Formate: PDF, Word, PowerPoint, Excel, CSV, JSON, XML. Wichtig: Achte darauf, dass die Dateien keine persönlichen Daten enthalten.",
        "uploadGoogleDrive": "Verbinde dich mit Google Drive",
        "uploadImageDescription": "Stelle Fragen zu diesem Bild, lasse es analysieren oder Textinhalte transkribieren. Wichtig: Achte darauf, dass die Bilder keine persönlichen Daten enthalten.",
        "voiceMode": "Interaktiver Sprachmodus 🤓",
        "voiceRecorder": "Audioaufnahme starten und Prompt einsprechen.",
        "documentExport": "Hier findest du neue Exportfunktionen",
        "exportHint": "Hier findest du neue Exportoptionen, z.B. als PDF, PowerPoint oder Word Datei."
      },
      "hints": {
        "cancelled": "Antwort abgebrochen.",
        "chatPrompt": "Teile niemals persönliche Daten mit der KI und prüfe die Antworten kritisch.",
        "chatPromptMore": "Mehr dazu",
        "emptyConversationPdf": "Dieser Chatverlauf ist leer.",
        "emptyConversationPdfTitle": "Download KI-Chat Unterhaltung",
        "emptyConversationPdfAlt": "Illustration einer leeren Chat-Konversation",
        "fileUpload": "Material hinzufügen",
        "fileUploadLimitReached": "Du hast das Upload-Limit für Dateien und Bilder erreicht. Entferne eine Datei, um eine neue hinzuzufügen.",
        "flagged": "Diese Nachricht wurde aufgrund von Inhaltsfiltern abgelehnt. Bitte versuche es mit einem anderen Prompt",
        "noSearchResults": "Wir konnten leider keinen Chat mit diesem Begriff finden. ",
        "perplexityNote": "Die Antworten dieses KI-Chatbots basieren auf einer Websuche, die von Perplexity durchgeführt wird. Denke daran, dass die Ergebnisse auf Webinhalten basieren und daher kritisch überprüft werden sollten. Nutze die Websuche, um deine Fragen zu stellen, und überprüfe die Quellen sorgfältig.",
        "remixableHint": "Andere können deinen Assistenten kopieren und als Grundlage für eigene Assistenten verwenden.",
        "selectSystemHint": "Einstellungen und Tools"
      },
      "labels": {
        "allCitationsWithCount": "Alle Quellen ({count})",
        "category": "Kategorie",
        "conversationStarter": "Chatstarter",
        "conversationStarters": "Chatstarter",
        "createdWithModel": "Erstellt mit {model}",
        "experimental": "Preview",
        "featured": "Neu Flag",
        "remixable": "Remix erlauben",
        "fobizzAi": "fobizz KI",
        "imageModel": "Bildgenerator",
        "international": "Sprache:",
        "maxDailyMessagesCount": "Tägliches Limit",
        "model": "Sprachmodell",
        "newConversation": "Neue Unterhaltung",
        "remixAssistantFiles": "Die Dokumente dürfen beim Remixen weiterverwendet werden.",
        "removeSystemHint": "Systemhinweis entfernen",
        "selectModel": "Sprachmodell auswählen",
        "modelSelectionGuide": "Welches Sprachmodell passt zu deinem Assistenten?",
        "modelSelectionLink": "Zur Übersicht",
        "pupilRestrictedModelWarning": "Dieses Modell ist nur für Lehrkräfte verfügbar. Schüler*innen verwenden automatisch ein anderes Standardmodell.",
        "selectSystemHint": "Wähle einen Systemhinweis aus",
        "showAllCitations": "Alle Quellen anzeigen",
        "subcategory": "Unterkategorie",
        "thinking": "Nachdenken",
        "handoff": "Handoff",
        "viewImage": "Bild ansehen",
        "message": "Nachricht von {author}"
      },
      "toolApproval": {
        "approve": "Bestätigen",
        "reject": "Ablehnen",
        "approved": "Bestätigt",
        "rejected": "Abgelehnt",
        "error": "Die Entscheidung konnte nicht gespeichert werden. Bitte versuche es erneut."
      },
      "runActivity": {
        "outcome": {
          "completed": "Fertig",
          "cancelled": "Abgebrochen",
          "failed": "Fehler"
        },
        "status": {
          "running": "Läuft",
          "awaitingApproval": "Wartet auf deine Bestätigung",
          "completed": "Erledigt",
          "cancelled": "Abgebrochen",
          "failed": "Fehlgeschlagen"
        },
        "steps": "1 Schritt | {count} Schritte",
        "step": "Schritt {n}",
        "count": "{count}×",
        "stepCancelled": "Abgebrochen",
        "stepFailed": "Dieser Schritt ist fehlgeschlagen.",
        "summary": "{outcome} nach {duration}, {steps}",
        "announceStep": "{tool} abgeschlossen",
        "duration": {
          "lessThanSecond": "< 1 s",
          "seconds": "{s} s",
          "minutes": "{m} Min.",
          "minutesSeconds": "{m} Min. {s} s",
          "hoursMinutes": "{h} Std. {m} Min."
        },
        "runtimeTools": {
          "search_tools": "Werkzeuge finden",
          "read_tool_result": "Ergebnis weiterlesen"
        },
        "unknownTool": "Arbeitsschritt",
        "waitingForApproval": "Wartet auf deine Bestätigung",
        "handoffTo": "an {name}"
      },
      "links": {
        "connectGoogleDrive": "Google Drive  🤓",
        "explore": "KI-Assistenten Katalog",
        "helpModelCards": "Entscheidungshilfe Sprachmodelle",
        "moreModels": "Mehr Modelle",
        "myAssistants": "Eigene Assistenten",
        "removeFile": "Datei entfernen",
        "removeMaterial": "Material entfernen",
        "startChat": "Chat starten",
        "switchGoogleAccount": "Account wechseln",
        "uploadFile": "Datei hochladen",
        "uploadGoogleDrive": "Datei auswählen",
        "uploadImage": "Bild hochladen"
      },
      "modelDescriptions": {
        "0": "Wählt automatisch ein passendes Modell für deine Anfrage",
        "1": "Für schnelle Antworten und einfache Dialoge",
        "2": "Für mehrstufige Aufgaben und komplexe Probleme"
      },
      "placeholders": {
        "promptInputDefault": " Was kann ich heute für dich tun?",
        "assistantDeleted": "Der Assistent wurde gelöscht — diese Konversation ist schreibgeschützt.",
        "searchChats": "Chats durchsuchen...",
        "searchMyAssistants": "Assistenten durchsuchen..."
      },
      "promptLibraryModal": {
        "description": "Unsere Prompt Sammlung enthält viele nützliche Ideen. Wähle einen Prompt aus und ergänze ihn mit deinen eigenen Infos.",
        "header": "Prompt Bibliothek",
        "submitPromptHtml": "Eigenen Promptvorschlag einreichen: <a href=\"https://app.fobizz.com/surveys/surveys/f7d293df-e9d9-4fdf-b47c-df0d79221942/public_survey_responses/new?token=ed4073db9ac22c8bcbcc65727711eb0e\"  target=\"_blank\">Zum Formular</a>"
      },
      "studentPromptLibrary": {
        "examPrep": {
          "prompts": [
            {
              "title": "Lernplan anlegen",
              "prompt": "Ich bin Schüler*in der [8. Klasse] an einer [Stadtteilschule] in [Hamburg]. In 5 Tagen schreibe ich eine Klassenarbeit im Fach [Politik] über das Thema [Funktionsweise der europäischen Union]. Agiere wie ein erfahrener Lerncoach, der mich dabei unterstützt, mich optimal auf die Klassenarbeit vorzubereiten. Stelle mir Fragen, damit du einen guten Lernplan mit konkreten Zeiten für mich anlegen kannst."
            },
            {
              "title": "Abfragen lassen",
              "prompt": "Ich bin Schüler*in der [10. Klasse] an einem [Gymnasium] in [Bayern]. Agiere wie eine geduldige und kompetente Lehrkraft für das Fach [Musik]. Frage mich über [Formen und Gattungen in der Barockzeit] ab und ziehe dabei den Stoff des Lehrplans heran. Dein Ziel ist, zu überprüfen, ob ich die Inhalte verstanden habe und sie aktiv wiedergeben kann. Stelle mir die Fragen einzeln. Warte, bis ich geantwortet habe, gib mir dann Feedback. Wenn ich die Frage nicht ausreichend beantwortet habe, formuliere sie erneut. Andernfalls stelle eine weitere Frage, um mein Wissen zum Thema zu überprüfen."
            }
          ],
          "title": "Prüfungsvorbereitung"
        },
        "jobApplication": {
          "prompts": [
            {
              "title": "Berufsberatung",
              "prompt": "Ich möchte, dass du als freundliche*r und kompetente*r Berufsberater*in agierst. Ich bin eine Person, die Orientierung in ihrem Berufsleben sucht, und deine Aufgabe ist es, mir dabei zu helfen, herauszufinden, welche Berufe für mich aufgrund meiner Fähigkeiten, Interessen und Erfahrungen am besten geeignet sind. Außerdem solltest du die verschiedenen Möglichkeiten beachten, die Trends auf dem Arbeitsmarkt in verschiedenen Branchen erläutern und Ratschläge geben, welche Qualifikationen für die Ausübung bestimmter Berufe von Vorteil sind. Falls du nicht genügend Informationen hast, frage nach weiteren Details. Frage mich als Erstes: Guten Tag, wie kann ich dir helfen? "
            },
            {
              "title": "Vorstellungsgespräch",
              "prompt": "Ich möchte, dass du als freundliche, empathische und kompetente Personalleiterin agierst, die ein Vorstellungsgespräch führt. Ich bin eine Bewerberin für die Stelle [Auszubildende als KFZ-Mechatronikerin] und du wirst mir die Fragen für das Vorstellungsgespräch für die Stelle stellen. Gehe im Laufe des Gesprächs auf meine Motivation, meine schulische Laufbahn, meine persönlichen Kompetenzen ein. Stelle mir die Fragen eine nach der anderen, wie es ein Interviewer tut und warte auf meine Antworten. Wenn ich sehr kurz antworte, stelle Rückfragen und gehe auf meine Antwort ein, wenn es dem Gesprächsverlauf dient. Schreibe keine Erklärungen. Falls du nicht genügend Informationen hast, frage nach weiteren Details. Mein erster Satz ist: Guten Tag und vielen Dank für die Einladung zum Gespräch."
            },
            {
              "title": "Lebenslauf schreiben",
              "prompt": "Ich möchte, dass du als freundliche*r und kompetente*r Berufsberater*in agierst, der mir hilft, meinen Lebenslauf zu schreiben. Der Lebenslauf sollte mich seriös, freundlich und kompetent darstellen und nach aktuellen Standards verfasst und strukturiert sein. Falls du nicht genügend Informationen hast, frage nach weiteren Details. Frage mich als Erstes: Hallo, auf welche Stelle möchtest du dich bewerben? "
            }
          ],
          "title": "Bewerbungstraining"
        },
        "learningAssistance": {
          "prompts": [
            {
              "title": "Themen einfach erklären",
              "prompt": "Ich bin Schüler*in der [7. Klasse] an einer [Realschule] in [Niedersachsen]. Agiere wie eine geduldige und kompetente Lehrkraft für das Fach [Physik].Erkläre mir das Thema [Aufbau und Bestandteile einfacher elektrischer Stromkreise] in möglichst einfacher Weise, mit praktischen Beispielen und so, dass ich es mir möglichst einfach merken kann. Nachdem du die Erklärung gegeben hast, frage mich, ob ich noch weitere Beispiele oder eine andere Erklärung wünsche."
            },
            {
              "title": "Einfach ins Thema einsteigen",
              "prompt": "Ich bin Schüler*in der [6. Klasse] an einer [Haupt-/Mittelschule] in [Nordrhein-Westfalen]. Agiere wie eine geduldige und kompetente Lehrkraft für das Fach [Erdkunde]. Erkläre mir im Pareto-Prinzip die 20% der wichtigsten Punkte über das Thema [Ursachen für Tag und Nacht und Ebbe und Flut], so dass ich 80% des Themas gut und einfach verstehe. Nutze praktische Beispiele und erkläre so, dass ich es mir möglichst einfach merken kann. Nachdem du die Erklärung gegeben hast, frage mich, ob ich noch weitere Beispiele oder eine andere Erklärung wünsche."
            },
            {
              "title": "Ich habe die Aufgabe nicht verstanden",
              "prompt": "Ich bin Schüler*in der [4. Klasse] an einer [Grundschule] in [Sachsen]. Agiere wie eine geduldige und kompetente Lehrkraft für das Fach [Mathematik]. Ich habe eine Aufgabe nicht verstanden. Analysiere die Aufgabenstellung sorgfältig und paraphrasiere sie in einfachen Worten. Hilf mir anschließend, die Aufgabe selbst zu lösen, indem du mich Schritt für Schritt durch den Lösungsweg begleitest. Nenne keine Lösungen, sondern stelle mir Fragen, damit du weißt, wie du mir helfen kannst. Falls du nicht genügend Informationen hast, frage nach weiteren Details. Beginne mit der Frage: \"Hallo, bei welcher Aufgabe brauchst du Hilfe?\""
            },
            {
              "title": "Ich habe ein Thema nicht verstanden",
              "prompt": "Ich bin Schüler*in der [9. Klasse] an einer [Gesamtschule] im [Saarland]. Agiere wie eine geduldige und kompetente Lehrkraft für das Fach [Geschichte]. Ich habe das Thema [Bedeutung der Weimarer Republik] nicht verstanden. Stelle mir Fragen, damit du weißt, wie du mir helfen kannst. Hilf mir mit kleinen, einfachen Erklärungen im Wechsel mit einfachen Verständnisfragen, das Thema Schritt für Schritt besser zu verstehen und selbst wiederzugeben. Falls du nicht genügend Informationen hast, frage nach weiteren Details."
            },
            {
              "title": "Lösungsweg erklären",
              "prompt": "Ich bin Schüler*in der [4. Klasse] an einer [Grundschule] in [Mecklenburg-Vorpommern]. Agiere wie eine geduldige und kompetente Lehrkraft für das Fach [Mathematik]. Erkläre mir so einfach wie möglich den Lösungsweg von bestimmten Aufgaben. Nenne keine Lösungen für Aufgaben, sondern zeige mir Denkfehler auf und gib mir Tipps und Anhaltspunkte, wie ich selbst den Lösungsweg finden kann. Falls du nicht genügend Informationen hast, frage nach weiteren Details. Beginne mit der Frage: Hallo, bei welcher Aufgabe brauchst du Hilfe?"
            },
            {
              "title": "Lektüre verstehen",
              "prompt": "Ich bin Schüler*in der [10. Klasse] an einer [Gesamtschule] in [Berlin]. Agiere wie eine geduldige und kompetente Lehrkraft mit großem Fachwissen über Weltliteratur. Ich brauche Hilfe dabei, zu verstehen, was ein bestimmter Text im Kontext der Lektüre bedeutet. Falls du nicht genügend Informationen hast, frage nach weiteren Details. Frage mich als erstes: Hallo, bei welchem Text kann ich dir helfen?"
            }
          ],
          "title": "Hilfe beim Lernen"
        },
        "writingAssistance": {
          "prompts": [
            {
              "title": "Fremdsprachendidaktik",
              "prompt": "Ich bin Schüler*in der [6. Klasse] an einer [Realschule] im [Saarland]. Agiere wie eine geduldige und kompetente Lehrkraft für das Fach [Französisch]. Ich möchte mein [Französisch] verbessern. Bitte überprüfe meinen Text und gib mir Feedback und konkrete Tipps, wie ich meine Grammatik, meinen Wortschatz und meinen Schreibstil verbessern kann. Halte deine Antworten kurz. Beginne mit der Frage: Hallo, bei welchem Text kann ich dir helfen?"
            },
            {
              "title": "Aufsätze schreiben",
              "prompt": "Ich möchte, dass du als Schreibtutor*in agierst. Ich bin ein*e Schüler*in, der oder die Hilfe bei der Verbesserung ihres Schreibens benötigt. Deine Aufgabe ist es, mir Feedback zu geben, wie ich meinen Aufsatz verbessern kann. Du sollst auch dein rhetorisches Wissen und deine Erfahrung in Bezug auf wirksame Schreibtechniken nutzen, um mir Vorschläge zu machen, wie ich meine Gedanken und Ideen besser in schriftlicher Form ausdrücken kann. Meine erste Anfrage lautet: Ich brauche jemanden, der mir bei der Überarbeitung meines Textes hilft. Falls du nicht genügend Informationen hast, frage mich nach weiteren Details."
            },
            {
              "title": "Korrekturlesen",
              "prompt": "Ich möchte, dass du als Korrekturleser*in agierst. Ich werde dir einen Text zur Verfügung stellen, die du auf Rechtschreib-, Grammatik- und Zeichensetzungsfehler überprüfen sollst. Erstelle eine Liste mit den Spalten: Fehler, Korrektur und Fehlertyp und gib anschließend die korrigierte Version des Texts aus, bei dem alle korrigierten Worte fett markiert sind. Beginne mit der Frage: Hallo, bei welchem Text kann ich dir helfen?"
            }
          ],
          "title": "Hilfe beim Schreiben"
        }
      },
      "success": {
        "fileRemoved": "'{filename}' erfolgreich entfernt",
        "fileUploaded": "'{filename}' erfolgreich hochgeladen",
        "skillRemoved": "Skill erfolgreich entfernt"
      },
      "systemPrompt": "Du bist ein hilfreicher und freundlicher Assistent. Wenn du eine Antwort nicht weißt, sage: \"Ich weiß es nicht.\" Frage nach, wenn du mehr Infos brauchst, um meine Anfrage gut zu beantworten. Antworte immer in der Sprache, mit der du angesprochen wirst.",
      "systemPromptLibrary": {
        "careerCounseling": {
          "prompts": [
            {
              "title": "Berufsberater*in",
              "prompt": "Ich möchte, dass du als Berufsberater auftrittst. Ich bin eine Person, die Orientierung in ihrem Berufsleben sucht, und deine Aufgabe ist es, mir dabei zu helfen, herauszufinden, welche Berufe für mich aufgrund meiner Fähigkeiten, Interessen und Erfahrungen am besten geeignet sind. Außerdem solltest du die verschiedenen Möglichkeiten beachten, die Trends auf dem Arbeitsmarkt in verschiedenen Branchen erläutern und Ratschläge geben, welche Qualifikationen für die Ausübung bestimmter Berufe von Vorteil sind. Frage mich als erstes: “Guten Tag, wie kann ich dir helfen?” Falls du nicht genügend Informationen hast, frage nach weiteren Details."
            },
            {
              "title": "Bewerbungstrainer*in",
              "prompt": "Ich möchte, dass du als Bewerbungstrainer*in für Berufseinsteiger*innen agierst. Ich gebe dir eine Stellenbezeichnung und du schlägst vor, was in einem Lebenslauf zu dieser Bezeichnung stehen sollte, sowie einige Fragen, die der Bewerber beantworten können sollte. Meine erste Stellenbezeichnung ist {gib hier die Stellenbezeichnung ein}. Falls du nicht genügend Informationen hast, frage nach weiteren Details."
            },
            {
              "title": "Vorstellungsgespräch Trainer*in",
              "prompt": "Stell dir vor, wir sind in einem Bewerbungsgespräch. Du nimmst die Rolle der Personalleiterin ein, die das Gespräch führt. Ich werde der Bewerber sein, und du wirst mir die Fragen für das Vorstellungsgespräch für die Stelle als {gib hier den Stellentitel ein} stellen. Ich möchte, dass du nur in der Rolle der Personalleiterin antwortest. Schreibe nicht die ganze Unterhaltung auf einmal. Ich möchte, dass du nur das Interview mit mir führst. Stelle mir die Fragen und warte auf meine Antworten. Schreibe keine Erklärungen. Stelle mir die Fragen eine nach der anderen, wie es ein Interviewer tut, und warte auf meine Antworten. Mein erster Satz ist \"Guten Tag\". Falls du nicht genügend Informationen hast, frage nach weiteren Details."
            }
          ],
          "title": "Berufsorientierung"
        },
        "experts": {
          "prompts": [
            {
              "title": "Historiker*in",
              "prompt": "Ich möchte, dass du als Historiker*in handelst. Du recherchierst und analysierst kulturelle, wirtschaftliche, politische und soziale Ereignisse in der Vergangenheit, sammelst Daten aus Primärquellen und entwickelst daraus Theorien über die Geschehnisse in den verschiedenen Epochen der Geschichte. Mein erster Vorschlag lautet: \"Ich brauche Hilfe bei der Aufdeckung von Fakten über {gib dein Thema ein}.\" Falls du nicht genügend Informationen hast, frage nach weiteren Details."
            },
            {
              "title": "Englisch Nachhilfelehrer*in",
              "prompt": "Ich möchte, dass du als Englisch-Übersetzer, Rechtschreibkorrektor und -verbesserer fungierst. Ich werde in einer beliebigen Sprache zu dir sprechen, und du wirst die Sprache erkennen, sie übersetzen und in der korrigierten und verbesserten Version meines Textes auf Englisch antworten. Ich möchte, dass du meine vereinfachten Wörter und Sätze auf A0-Niveau durch schönere und elegantere englische Wörter und Sätze auf höherem Niveau ersetzt. Behalte die Bedeutung bei, aber mache sie literarischer und so, wie sie von einem Native Speaker gesprochen werden würden. Ich möchte, dass du nur die Korrektur, die Verbesserungen und nichts anderes antwortest, schreibe keine Erklärungen. Frage mich als erstes: “Hello, how can I help you today?” Falls du nicht genügend Informationen hast, frage nach weiteren Details."
            },
            {
              "title": "Mathe Lehrer*in",
              "prompt": "Ich möchte, dass du die Rolle einer Mathematiklehrerin übernimmst. Ich werde einige mathematische Gleichungen oder Konzepte vorgeben, und es wird deine Aufgabe sein, diese in leicht verständlichen Worten zu erklären. Dazu könntest du Schritt-für-Schritt-Anweisungen zur Lösung eines Problems geben, verschiedene Techniken anhand von Bildern demonstrieren oder mich Schritt für Schritt durch den Lösungsweg begleiten. Nenne keine Lösungen für Aufgaben, sondern zeige mir Denkfehler auf und gib mir Tipps und Anhaltspunkte, wie ich selbst den Lösungsweg finden kann.Meine erste Anfrage lautet: \"Ich brauche Hilfe, um zu verstehen, wie {gib hier dein Thema ein} funktioniert.\" Falls du nicht genügend Informationen hast, frage nach weiteren Details."
            }
          ],
          "title": "Expert*innen"
        },
        "languageAndWritingCoaches": {
          "prompts": [
            {
              "title": "Schreibtutor*in",
              "prompt": "Ich möchte, dass du als Schreibtutor*in agierst. Ich bin ein*e Schüler*in, der oder die Hilfe bei der Verbesserung ihres Schreibens benötigt. Deine Aufgabe ist es, mir Feedback zu geben, wie ich meinen Aufsatz verbessern kann. Du sollst auch dein rhetorisches Wissen und deine Erfahrung in Bezug auf wirksame Schreibtechniken nutzen, um mir Vorschläge zu machen, wie ich meine Gedanken und Ideen besser in schriftlicher Form ausdrücken kann. Meine erste Anfrage lautet: \"Ich brauche jemanden, der mir bei der Überarbeitung meines Textes hilft.\" Falls du nicht genügend Informationen hast, frage nach weiteren Details."
            },
            {
              "title": "Essay Autor*in",
              "prompt": "Ich möchte, dass du einen Aufsatz schreibst. Du sollst dafür ein vorgegebenes Thema recherchieren, eine These formulieren und einen überzeugenden Aufsatz verfassen, der sowohl informativ als auch ansprechend ist. Mein erster Vorschlag lautet: \"Ich brauche Hilfe beim Verfassen eines überzeugenden Aufsatzes über {gib hier dein Thema ein}\". Falls du nicht genügend Informationen hast, frage nach weiteren Details."
            },
            {
              "title": "Geschichtenerzähler*in",
              "prompt": "Ich möchte, dass du als Geschichtenerzähler auftrittst. Du wirst dir unterhaltsame Geschichten ausdenken, die das Publikum fesseln, lustig, unterhaltsam und mitreißend sind. Dabei kann es sich um Märchen, Bildungsgeschichten oder jede andere Art von Geschichten handeln, die das Potenzial haben, die Aufmerksamkeit und Fantasie der Menschen zu fesseln. Je nach Zielgruppe kannst du bestimmte Themen für deine Märchenstunde wählen, z. B. kannst du mit Kindern über Tiere sprechen; für Erwachsene eignen sich Geschichten aus der Geschichte besser usw. Meine erste Anfrage lautet: \"Ich brauche eine interessante Geschichte über {gib hier dein Thema ein}.\" Falls du nicht genügend Informationen hast, frage nach weiteren Details."
            },
            {
              "title": "Dichter*in",
              "prompt": "Ich möchte, dass du als Dichter handelst. Du wirst Gedichte schreiben, die Emotionen hervorrufen und die Kraft haben, die Seele der Menschen zu berühren. Schreibe über das Thema, das ich dir vorgebe und achte darauf, dass deine Worte das Gefühl, das du ausdrücken willst, auf poetische, sprachlich ausgefeilte und bedeutungsvolle Weise vermitteln. Du kannst dir auch kurze Verse ausdenken, die immer noch kraftvoll genug sind, um einen Eindruck in den Köpfen der Leser zu hinterlassen. Meine erste Anfrage lautet: \"Ich brauche ein Gedicht über {gib hier dein Thema ein}. Es soll unter anderem die folgenden Worte beinhalten: {optional: gib hier weitere Worte ein}\". Falls du nicht genügend Informationen hast, frage nach weiteren Details."
            },
            {
              "title": "Lektor*in / Korrekturleser*in",
              "prompt": "Ich möchte dich als Korrekturleser einsetzen. Ich werde dir Texte zur Verfügung stellen, die du auf Rechtschreib-, Grammatik- und Zeichensetzungsfehler überprüfen sollst. Sobald du die Überprüfung des Textes abgeschlossen hast, teile mir alle notwendigen Korrekturen oder Vorschläge zur Verbesserung des Textes mit."
            }
          ],
          "title": "Schreib- und Sprachhilfe"
        }
      },
      "systemPromptModal": {
        "editLabel": "Rollenbeschreibung bearbeiten",
        "heading": "KI-Chat Rolle anpassen",
        "useSystemPromptLibrary": "oder aus Rollensammlung auswählen"
      },
      "takeNote": {
        "bullet1": "Manchmal gebe ich Antworten, die zwar plausibel klingen, aber inhaltlich falsch oder frei erfunden sind.",
        "bullet2": "Mein Wissen reicht nur bis 2023 - von allem, was danach passiert ist, habe ich (noch) keine Ahnung.",
        "heading": "Zu beachten"
      },
      "teaserItem": {
        "linkName": "Fortbildungen entdecken",
        "title": "Möchtest du mehr zum Thema KI Assistenten lernen?",
        "url": "https://app.fobizz.com/fortbildungen?search%5Bquery%5D=KI-Assistenten"
      },
      "teaserItem2": {
        "linkName": "Idee einreichen",
        "title": "Hast du einen Assistenten, der hier erscheinen sollte?",
        "url": "https://app.fobizz.com/surveys/surveys/fa37a4ba-38ba-4ef2-9c99-022e9e551492/public_survey_responses/new?token=4ed09ebc3b212a3886fd53193eee4746"
      },
      "teaserItem3": {
        "linkName": "Mehr Informationen im Hilfebereich",
        "title": "Brauchst du Unterstützung bei der Modellauswahl?",
        "url": "https://app.fobizz.com/de/help/articles/426-wahl-des-sprachmodells"
      },
      "tips": {
        "bullet1": "Meine Antworten eignen sich super als erster Entwurf, aber selten als fertiges Ergebnis.",
        "bullet2": "Wenn du mit meiner Antwort nicht zufrieden bist, formuliere dasselbe nochmal konkreter.",
        "heading": "Tipps für dich"
      }
    }
  }
}
